import { useEffect, useState } from 'react';
import type { Achievement } from '@/services/ProgressionService';
import { gameBridge } from '@/services/GameBridge';

interface ToastState {
  achievement: Achievement;
  expiresAt: number;
}

export function AchievementToast() {
  const [toast, setToast] = useState<ToastState | null>(null);

  useEffect(() => {
    const unsub = gameBridge.subscribe('achievement-unlocked' as any, ({ achievement }) => {
      setToast({
        achievement,
        expiresAt: Date.now() + 4500,
      });
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!toast) return;
    const timer = setInterval(() => {
      if (Date.now() > toast.expiresAt) {
        setToast(null);
      }
    }, 250);
    return () => clearInterval(timer);
  }, [toast]);

  if (!toast) return null;

  return (
    <div className="pointer-events-none fixed bottom-8 left-1/2 -translate-x-1/2 z-50">
      <div className="pointer-events-auto flex items-center gap-4 rounded-xl bg-gradient-to-r from-amber-500 via-orange-500 to-pink-500 px-6 py-4 shadow-2xl shadow-orange-700/50 ring-2 ring-white/40 animate-slide-up backdrop-blur-sm">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-black/40 text-white text-2xl font-bold animate-bounce-subtle shadow-lg">
          ✦
        </div>
        <div className="text-white pr-2">
          <div className="text-xs uppercase tracking-widest opacity-90 font-semibold mb-1">Achievement Unlocked</div>
          <div className="text-base font-bold leading-tight mb-1">{toast.achievement.name}</div>
          <div className="text-xs opacity-95 leading-snug">{toast.achievement.description}</div>
        </div>
      </div>
    </div>
  );
}
